import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileGeoTiff.tsx
const IconFileGeoTiff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#798a10",
			fillRule: "evenodd",
			d: "M9 10a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-9m2.716 5.042v3.378h-.912v-3.378H9.67v-.81h3.18v.81zm1.572 2.652v.726h1.992v-.726h-.54v-2.736h.54v-.726h-1.992v.726h.54v2.736zm2.752.726v-4.188h2.778v.81h-1.866v.858h1.59v.804h-1.59v1.716zm3.51-4.188v4.188h.912v-1.716h1.59V15.9h-1.59v-.858h1.866v-.81z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#c8cf9d",
			d: "M11.553 12.976h-.02a.53.53 0 0 1-.216.352q-.185.14-.5.14-.24 0-.448-.092a1 1 0 0 1-.364-.272 1.3 1.3 0 0 1-.244-.448 2 2 0 0 1-.088-.62q0-.352.092-.624.09-.271.256-.456.168-.184.4-.28.231-.096.516-.096.375 0 .648.164.271.16.428.484l-.496.284a.66.66 0 0 0-.2-.276q-.137-.116-.38-.116-.284 0-.452.164t-.168.516v.448q0 .348.168.516a.62.62 0 0 0 .452.164 1 1 0 0 0 .212-.024.6.6 0 0 0 .176-.08.4.4 0 0 0 .116-.132q.044-.075.044-.18v-.14h-.52v-.508h1.1v1.556h-.512zM12.656 13.42v-2.792h1.9v.54h-1.292v.572h1.108v.536h-1.108v.604h1.292v.54zM16.205 13.468q-.276 0-.504-.092a1 1 0 0 1-.388-.272 1.3 1.3 0 0 1-.248-.452 2 2 0 0 1-.088-.628q0-.355.088-.624.089-.272.248-.452.16-.184.388-.276t.504-.092.504.092q.229.091.388.276.16.18.248.452.088.269.088.624 0 .356-.088.628-.087.269-.248.452-.16.18-.388.272t-.504.092m0-.54a.53.53 0 0 0 .428-.18q.156-.18.156-.516v-.416q0-.336-.156-.516a.53.53 0 0 0-.428-.18.54.54 0 0 0-.432.18q-.152.18-.152.516v.416q0 .336.152.516.156.18.432.18"
		})
	]
});
var IconFileGeoTiff_default = forwardRef(IconFileGeoTiff);
//#endregion
export { IconFileGeoTiff_default as default };
